import { render, staticRenderFns } from "./TruncatedText.vue?vue&type=template&id=028bcd4a&scoped=true&"
import script from "./TruncatedText.vue?vue&type=script&lang=ts&"
export * from "./TruncatedText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bcd4a",
  null
  
)

export default component.exports